import React from "react";

const BlackArrowDownIcon = ({ color = "var(--color-text-primary)" }) => {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
			<path
				d="M1.5 6L6 10.5L10.5 6"
				stroke={color}
				strokeWidth="2.4"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	);
};

export default BlackArrowDownIcon;
